import { useMutation, useQueryClient } from '@tanstack/react-query';

import { session } from '@/shared/session/session';

import { authApi } from '../api/auth-api';
import { isTwoFactorChallenge } from '../schemas/two-factor-rules';

/**
 * Signs in, then refreshes /me so route guards see the new session before navigation. A 202
 * challenge sets no cookie, so the session is only refreshed for a real token response.
 */
export function useLogin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: authApi.login,
    meta: { silentError: true },
    onSuccess: async (result) => {
      if (!isTwoFactorChallenge(result)) await session.refreshSession(queryClient);
    },
  });
}
